import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchIconColors } from '../services/justificaciones';
import { TipoJornadaInfo } from 'components/Types/GeneralTypes';

const IconColorContext = createContext<TipoJornadaInfo[] | null>(null);

export const IconColorProvider = ({ children }) => {
    const [iconColors, setIconColors] = useState<TipoJornadaInfo[]>([]);

    useEffect(() => {
        let isMounted = true; 

        const fetchAndSetIconColors = async () => {
            try {
                const colors = await fetchIconColors();
                if (isMounted) {
                    setIconColors(colors || []);
                }
            } catch (error) {
                console.error("Failed to fetch icon colors:", error);
                if (isMounted) {
                    setIconColors([]); 
                }
            }
        };

        fetchAndSetIconColors();

        return () => {
            isMounted = false; 
        };
    }, []);

    return (
        <IconColorContext.Provider value={iconColors}>
            {children}
        </IconColorContext.Provider>
    );
};

export const useIconColors = () => useContext(IconColorContext);
